/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import track from 'c9-tracking';
import { ReactComponent as NordeaLogo } from '../../assets/NordeaLogo.svg';
import { RenderHtml } from '../shared/RenderHtml';
import { useFetchContent } from '../../hooks/useFetchContent';
import './nordea-banner.css';
import { useEffect } from 'react';

export const NordeaBanner = () => {
    const { contentBlocks } = useFetchContent({
        urls: [{ prop: 'nordeaBanner', url: '/common/nordea-banner&template=nowrapper' }]
    });

    useEffect(() => {
        track.info('Showing Nordea banner to customer');
    }, []);

    const navigateToNordea = () => {
        track.info('Nordea banner clicked');
    };

    return (
        <article className="nordea-banner">
            <div className="nordea-banner-left-column">
                <NordeaLogo className="nordea-logo" />
            </div>
            <div className="nordea-banner-right-column">
                <span onClick={navigateToNordea} role="alert" onKeyDown={navigateToNordea}>
                    <RenderHtml>{(contentBlocks as any)?.nordeaBanner}</RenderHtml>
                </span>
            </div>
        </article>
    );
};
